import { ConnectorCredentialsConfig, ConnectorEnum, Maybe } from '../generated/graphql';

export const getConnectionType = (partnerConfig: Maybe<ConnectorCredentialsConfig>) => {
    if (partnerConfig?.__typename === 'MewsCredentialsConfig') {
        return ConnectorEnum.Mews;
    }

    if (partnerConfig?.__typename === 'MaxxtonCredentialsConfig') {
        return ConnectorEnum.Maxxton;
    }

    return undefined;
};
